import { useTranslation } from '@govard/i18n-core/react';
import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card } from 'antd';

export default function NotFoundPage(): ReactElement {
  const { t } = useTranslation();

  return (
    <main
      className="animate-fade-in flex min-h-screen items-center justify-center p-6"
      style={{ backgroundColor: 'var(--ant-color-bg-layout)' }}
    >
      <Card style={{ width: '100%', maxWidth: 400 }}>
        <div className="mb-6">
          {/* Точечный amber-акцент: крупное tabular «404» над заголовком. */}
          <div
            aria-hidden="true"
            style={{
              fontSize: 32,
              fontWeight: 600,
              letterSpacing: '-0.02em',
              fontVariantNumeric: 'tabular-nums',
              color: 'var(--ant-color-primary)',
              lineHeight: 1.2,
            }}
          >
            404
          </div>
          <h1
            style={{
              fontSize: 17,
              fontWeight: 600,
              letterSpacing: '-0.015em',
              color: 'var(--ant-color-text)',
            }}
          >
            {t('crm.not_found.title')}
          </h1>
          <p style={{ fontSize: 13, color: 'var(--ant-color-text-tertiary)', marginTop: 4 }}>
            {t('crm.not_found.description')}
          </p>
        </div>

        <div className="flex flex-col gap-3 mt-2 sm:flex-row">
          <Link data-testid="not-found-home" to="/dashboard" style={{ flex: 1 }}>
            <Button type="primary" block>
              {t('crm.not_found.home')}
            </Button>
          </Link>
          <Link data-testid="not-found-login" to="/login" style={{ flex: 1 }}>
            <Button block>{t('crm.not_found.login')}</Button>
          </Link>
        </div>
      </Card>
    </main>
  );
}
